export const GET_ALL_PRIVILEGES = "GET_ALL_PRIVILEGES";
